<template>
  <div class="subpage">
    <Header title="风水罗盘" :is-sub-page="true"></Header>
    <div>111111</div>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  components: {
    Header
  },
  mounted () {
  }
}
</script>

<style>

</style>
